import invariant from 'tiny-invariant';

export interface Config {
  // Application
  APPLICATION_NAME: string;
  NODE_ENV?: string;
  LOG_LEVEL?: string;
  VERSION: string;

  // APIs
  API_URI: string;
  GRAPHQL_URI: string;
  PRODUCTS_URI: string;

  // Telemetry
  BRANCH_API_KEY?: string;
  BRAZE_API_KEY?: string;
  SEGMENT_API_KEY?: string;
  SENTRY_DESIGN_STUDIO_DSN?: string;
  SENTRY_DSN?: string;
  SPLIT_API_KEY?: string;

  // Firebase
  EMULATOR_FIREBASE_AUTH?: string;
  EMULATOR_FIREBASE_FIRESTORE?: string;
  FIREBASE_API_KEY?: string;
  FIREBASE_APP_ID?: string;
  FIREBASE_AUTH_DOMAIN?: string;
  FIREBASE_DATABASE_URL?: string;
  FIREBASE_MEASUREMENT_ID?: string;
  FIREBASE_MESSAGING_SENDER_ID?: string;
  FIREBASE_PROJECT_ID?: string;
  FIREBASE_STORAGE_BUCKET?: string;
}

const env = typeof window !== 'undefined' ? window.env : process.env;

invariant(
  env.GRAPHQL_URI && typeof env.GRAPHQL_URI === 'string',
  '💣💥 ENV_CONFIG_ERROR: The "GRAPHQL_URI" value is not a valid string',
);

invariant(
  env.API_URI && typeof env.API_URI === 'string',
  '💣💥 ENV_CONFIG_ERROR: The "API_URI" value is not a valid string',
);

invariant(
  env.PRODUCTS_URI && typeof env.PRODUCTS_URI === 'string',
  '💣💥 ENV_CONFIG_ERROR: The "PRODUCTS_URI" value is not a valid string',
);

const config: Config = {
  // Application
  APPLICATION_NAME: 'web-react',
  LOG_LEVEL: env.LOG_LEVEL,
  NODE_ENV: env.NODE_ENV,
  // Don't read from isomorphic `env` here because this gets
  // replaced at build time and must include `process.env`
  VERSION: process.env.RAZZLE_GIT_HEAD_SHA ?? 'local',

  // APIs
  API_URI: env.API_URI,
  GRAPHQL_URI: env.GRAPHQL_URI,
  PRODUCTS_URI: env.PRODUCTS_URI,

  // Telemetry
  BRANCH_API_KEY: env.BRANCH_API_KEY,
  BRAZE_API_KEY: env.BRAZE_API_KEY,
  SEGMENT_API_KEY: env.SEGMENT_API_KEY,
  SENTRY_DESIGN_STUDIO_DSN: env.SENTRY_DESIGN_STUDIO_DSN,
  SENTRY_DSN: env.SENTRY_DSN,
  SPLIT_API_KEY: env.SPLIT_API_KEY,

  // Firebase
  EMULATOR_FIREBASE_AUTH: env.EMULATOR_FIREBASE_AUTH,
  EMULATOR_FIREBASE_FIRESTORE: env.EMULATOR_FIREBASE_FIRESTORE,
  FIREBASE_API_KEY: env.FIREBASE_API_KEY,
  FIREBASE_APP_ID: env.FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN: env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL: env.FIREBASE_DATABASE_URL,
  FIREBASE_MEASUREMENT_ID: env.FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID: env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID: env.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: env.FIREBASE_STORAGE_BUCKET,
};

export { config };
